import { createServerFn } from "@tanstack/react-start";
import * as db from "@/lib/db.server";

// ponytail: module-level cache per warm Lambda container, 60s TTL — same
// pattern as search-providers.functions.ts. This query already only touches
// the small precomputed provider_city_counts table (not the 6M-row providers
// table), so the cache is just extra headroom, not a correctness requirement.
const _cache = new Map<string, { rows: CityCount[]; expires: number }>();
const CACHE_TTL_MS = 60_000;

export type CityCount = { city: string; state: string; count: number };

export const searchCitiesWithCountsFn = createServerFn({ method: "GET" })
  .inputValidator((d: { q: string }) => d)
  .handler(async ({ data }): Promise<CityCount[]> => {
    const q = data.q.trim();
    if (q.length < 2) return [];
    const key = q.toLowerCase();
    const now = Date.now();
    const hit = _cache.get(key);
    if (hit && hit.expires > now) return hit.rows;

    const rows = await db.query<CityCount>(
      `SELECT city, state, count FROM public.provider_city_counts
       WHERE lower(city) LIKE lower($1) || '%'
       ORDER BY count DESC
       LIMIT 8`,
      [q],
    );
    _cache.set(key, { rows, expires: now + CACHE_TTL_MS });
    if (_cache.size > 500) {
      const oldestKey = _cache.keys().next().value;
      if (oldestKey) _cache.delete(oldestKey);
    }
    return rows;
  });
